<template>
  <div class="login">
    <div class="jk-mb-[70px]">
      <img
        src="@/assets/images/login_icon.png"
        alt="Login Icon"
        style="max-width: 400px; height: auto; display: block; margin: 0 auto;"
      />

    </div>
    <div class="formView">
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <h3 class="title">猎题豹管理系统登录</h3>
        <el-form-item prop="username" class="!jk-mb-[30px]">
          <el-input v-model="loginForm.username" @input="loginForm.username = loginForm.username.replace(/\s+/g, '')" clearable type="text" auto-complete="off" maxlength="11" placeholder="账号">
            <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password" class="!jk-mb-[30px]">
          <el-input v-model="loginForm.password" clearable type="password" @input="loginForm.password = loginForm.password.replace(/\s+/g, '')" show-password class="jk-bg-[#DFE9F5] jk-rounded-[4px]" auto-complete="off" placeholder="密码" @keyup.enter.native="handleLogin">
            <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
          </el-input>
        </el-form-item>
        <!-- <el-form-item prop="code" v-if="captchaEnabled" class="!jk-mb-[30px]">
          <el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" clearable style="width: 63%" @keyup.enter.native="handleLogin">
            <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
          </el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </el-form-item> -->
        <el-checkbox v-model="loginForm.rememberMe" class="!jk-mb-[30px]">记住密码</el-checkbox>
        <el-form-item style="width: 100%">
          <el-button :loading="loading" size="medium" type="primary" class="jk-h-[54px] !jk-text-[20px] jk-font-[500]" style="width: 100%" @click.native.prevent="handleLogin">
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
          <div style="float: right" v-if="register">
            <router-link class="link-type" :to="'/register'">立即注册</router-link>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--  底部  -->
    <!--    <div class="el-login-footer">
      <span>Copyright © 2018-2023 疯狂的狮子Li All Rights Reserved.</span>
    </div>-->
  </div>
</template>

<script>
  // import { getCodeImg } from '@/api/login';
  import Cookies from 'js-cookie';
  import { encrypt, decrypt } from '@/utils/jsencrypt';
  // import { validatePass } from '@/utils/validate';

  export default {
    name: 'Login',
    data() {
      return {
        codeUrl: '',
        loginForm: {
          username: '',
          password: '',
          rememberMe: false,
          // code: '',
          uuid: '',
        },
        loginRules: {
          username: [{ required: true, trigger: 'blur', message: '请输入您的账号' }],
          password: [
            { required: true, trigger: 'blur', message: '请输入您的密码' },
            // {
            //   validator: (rule, value, callback) => {
            //     if (!validatePass(value)) {
            //       callback(new Error('密码 8-20 位，含大小写字母、数字中至少 2 种'));
            //     } else {
            //       callback();
            //     }
            //   },
            //   trigger: 'blur',
            // },
          ],
          // code: [{ required: true, trigger: 'change', message: '请输入验证码' }],
        },
        loading: false,
        // 验证码开关
        captchaEnabled: true,
        // 注册开关
        register: false,
        redirect: undefined,
      };
    },
    watch: {
      $route: {
        handler: function (route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true,
      },
      'loginForm.username': {
        handler: function (newVal, oldVal) {
          if (newVal === '') {
            this.loginForm.password = '';
          }
        },
      },
    },
    created() {
      // this.getCode();
      this.getCookie();
    },
    methods: {
      // getCode() {
      //   getCodeImg().then((res) => {
      //     this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled;
      //     if (this.captchaEnabled) {
      //       this.codeUrl = 'data:image/gif;base64,' + res.data.img;
      //       this.loginForm.uuid = res.data.uuid;
      //     }
      //   });
      // },
      getCookie() {
        const username = Cookies.get('username');
        const password = Cookies.get('password');
        const rememberMe = Cookies.get('rememberMe');
        this.loginForm = {
          username: username === undefined ? this.loginForm.username : username,
          password: password === undefined ? this.loginForm.password : decrypt(password),
          rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        };
      },
      handleLogin() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.loginForm.rememberMe) {
              Cookies.set('username', this.loginForm.username, { expires: 30 });
              Cookies.set('password', encrypt(this.loginForm.password), { expires: 30 });
              Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
            } else {
              Cookies.remove('username');
              Cookies.remove('password');
              Cookies.remove('rememberMe');
            }
            this.$store
              .dispatch('Login', this.loginForm)
              .then(() => {
                this.$router.push({ path: this.redirect || '/' }).catch(() => {});
              })
              .catch(() => {
                this.loading = false;
                // if (this.captchaEnabled) {
                //   this.getCode();
                // }
              });
          }
        });
      },
    },
  };
</script>

<style rel="stylesheet/scss" lang="scss">
  .login {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-image: url('../assets/images/login-bg.png');
    background-size: cover;
    column-gap: 200px;
  }
  .title {
    margin: 0 auto 50px auto;
    text-align: center;
    font-family: SourceHanSansSC-Bold;
    font-weight: 700;
    font-size: 30px;
    color: #2a78ed;
  }
  .formView {
    display: flex;
    justify-content: flex-end;
    border-radius: 16px;
    width: 1001px;
    background-image: url('../assets/images/login-form-bg.png');
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 250, 250, 0.45);
    .login-form {
      width: 500px;
      padding: 70px 50px;
      .el-input {
        height: 50px;
        input {
          color: #566683;
          font-size: 16px;
          font-weight: 400;
          background: #dfe9f5;
          border: 1px solid #faf5f5;
          border-radius: 4px;
          height: 50px;
          padding-left: 40px;
        }
      }
      .input-icon {
        height: 50px;
        width: 14px;
        margin-left: 10px;
        color: #86b2e6;
      }
    }
  }
  .login-tip {
    font-size: 13px;
    text-align: center;
    color: #bfbfbf;
  }
  .login-code {
    width: 33%;
    height: 38px;
    float: right;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #333333;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
  }
  .login-code-img {
    height: 38px;
  }
</style>
